import type { ReactNode } from 'react';

type Props = {
  actions?: ReactNode;
};

/**
 * Optional action row under the topbar (create buttons, etc.).
 * Page title lives only in the topbar — no descriptions here.
 */
export function PageHeader({ actions }: Props) {
  if (!actions) return null;

  return (
    <div className="page-heading page-heading--compact d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
      <div className="d-flex flex-wrap gap-2 page-heading__actions">{actions}</div>
    </div>
  );
}
